import Vue from 'vue'

const getProgramacao = async (numPedido) => {
  try {
    const response = await Vue.prototype.$http.get(`/pedido/${numPedido}/programacao`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getExtrato = async (numPedido) => {
  try {
    const response = await Vue.prototype.$http.get(`/pedido/${numPedido}/extrato`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

export {
  getProgramacao,
  getExtrato
}